import React from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import {
    Flex,
    Box,
    Center
} from "@chakra-ui/react";

const Layout = ({ children }) => {
    return (
        <React.Fragment>
            <Flex direction="column" minHeight="100vh">
                <Flex flex="1" background="gray.100">
                    <Center>
                        <Sidebar />
                    </Center>
                    <Box flex="1" display="flex" flexDirection="column">
                        <main style={{ flex: 1 }}>{children}</main>
                    </Box>
                </Flex>
                <Footer />
            </Flex>
        </React.Fragment>
    );
};
export default Layout;